<template>
    <b-card>
        <b-row>
            <b-col lg="12">
                <b-card header="Select a Date Range and a Report"
                        header-text-variant="white"
                        header-bg-variant="info"
                >
                    <form class="form form-inline" @submit.prevent="downloadReport()" method="get">
                        <date-picker
                                v-model="start_date"
                                placeholder="Start Date"
                                required
                        >
                        </date-picker> &nbsp;to&nbsp;
                        <date-picker
                                v-model="end_date"
                                placeholder="End Date"
                                required
                        >
                        </date-picker>
                        <b-form-select
                                id="report_route"
                                name="report_route"
                                v-model="report_route"
                                class="ml-1 mr-1"
                                required
                        >
                            <option value="">Select a Report</option>
                            <option v-for="report in reports" :value="report.route" :key="report.route">{{ report.name }}</option>
                        </b-form-select>
                        <carrier-dropdown v-model="carrier" class="ml-1 mr-1" emptyText="All Carrier"></carrier-dropdown>
                        <b-button type="submit" variant="info" :disabled="loading" class="mt-2">Download Spreadsheet</b-button>
                    </form>
                </b-card>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    export default {
        name: "BusinessShiftExports",

        data() {
            return {
                start_date: moment().format('MM/01/YYYY'),
                end_date: moment().format("MM/") + moment().daysInMonth() + moment().format("/YYYY"),
                report_route: "",
                reports: [
                    {
                        'route': 'shift-activities',
                        'name': 'All Shifts and Activities',
                    },
                    {
                        'route': 'manual-shifts',
                        'name': 'Manual Shifts',
                    },
                    {
                        'route': 'modified-shifts',
                        'name': 'Modified Shifts',
                    },
                ],
                carrier: '',
                loading: false,
            }
        },

        computed: {
            reportUrl() {
                return `/business/exports/${this.report_route}?start_date=${this.start_date}&end_date=${this.end_date}&carrier=${this.carrier}`;
            }
        },

        methods: {
            downloadReport() {
                window.location.href = this.reportUrl;
            }
        }
    }
</script>

<style scoped>

</style>